import { render } from "./UpdateRequestForm.vue?vue&type=template&id=849240ae&scoped=true&ts=true"
import script from "./UpdateRequestForm.vue?vue&type=script&lang=ts"
export * from "./UpdateRequestForm.vue?vue&type=script&lang=ts"

import "./UpdateRequestForm.vue?vue&type=style&index=0&id=849240ae&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849240ae"]])

export default __exports__